// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
  height: 100vh;
}

.scroll-bar {
  height: calc(100vh - 120px);
  overflow-y: auto;
}

.card-image {
  display: flex;
  justify-content: center;
  padding-top: 10px;
}

.flex-item {
  width: 265px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/userandgroup/user/userlist/userlist.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACD,aAAA;AACH;;AACA;EACI,2BAAA;EACA,gBAAA;AAEJ;;AAAA;EACI,aAAA;EACA,uBAAA;EACA,iBAAA;AAGJ;;AADA;EACI,uBAAA;AAIJ","sourcesContent":[":host{\n    width: 100%;\n   height:100vh;\n}\n.scroll-bar{\n    height: calc(100vh - 120px);\n    overflow-y: auto;\n}\n.card-image{\n    display: flex;\n    justify-content: center;\n    padding-top:10px;\n}\n.flex-item{\n    width:265px !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
